@let light = variant() === 'light';

<!-- NOTE: We use queryParamsHandling="preserve" here to make sure
           the ecmp header queryParam will stay on navigation -->
<a
  [attr.aria-label]="label()"
  role="link"
  [routerLink]="url()"
  queryParamsHandling="preserve"
  class="navbar-brand navigation__logo"
  [class.navigation__logo--light]="light"
>
  <wl-logo [variant]="variant()" [width]="width()" [height]="height()" />
</a>
